import React from "react";
import { useAppSelector } from "@/services/hooks";
import useMediaBrowser from "../browser/useMediaBrowser";
import MediaBrowserView from "../browser/MediaBrowserView";
import type { MediaImage } from "./ImageInformation";

export type IndexModelMediaContainerProps = {
  SelectedImage?: (image: MediaImage) => void;
};

/**
 * Modal image picker browser: thin wrapper around the shared browser core
 * (SCRUM-904) in "select" mode — browse + click an image to pick it (forwarded to
 * ModelMediaContainer's confirm step via SelectedImage). Opens scoped to the current
 * context: an explicitly set Cloudinary path (s.images.path, e.g. "USERS" on Add User)
 * or otherwise the editing site's country_code folder. Home still returns to root.
 */
const IndexModelMediaContainer = ({ SelectedImage = () => {} }: IndexModelMediaContainerProps) => {
  const site = useAppSelector((s) => s.sites.site);
  const cloudinaryPath = useAppSelector((s) => s.images.path) || "";
  const initialPath = cloudinaryPath || site?.country_code || "";

  const vm = useMediaBrowser({
    mode: "select",
    initialPath,
    rootPath: "",
    onSelect: SelectedImage,
  });

  return <MediaBrowserView {...vm} />;
};

export default IndexModelMediaContainer;
